import React from 'react';
import { useTranslation } from 'react-i18next';
import { BackToFiltersButtonContainer } from './styled';
import Icon from '../../Icon';
import { Typography } from '../../ui/Typography';
import BackToFiltersIcon from '../../../public/static/images/new_search/icons/back-to-filters.svg';

export const BackToFiltersButton: React.FC = () => {
  const { t } = useTranslation();

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <BackToFiltersButtonContainer onClick={scrollToTop}>
      <Icon
        width={16}
        height={16}
        IconComponent={BackToFiltersIcon}
        indent={false}
      />
      <Typography tag="body_1">{t('search.buttons.rise')}</Typography>
    </BackToFiltersButtonContainer>
  );
};
